/* FYNDMAXA: fraktmätare — röd (under 150 kr), gul (150–698 kr), grön (699 kr+).
   Uppdaterar alla instanser (flytande bar + varukorg) från samma /cart.js-hämtning
   så de alltid visar identisk status. Endast den flytande baren göms när vagnen är tom.
   Färg och bredd sätts direkt inline så det alltid syns korrekt oavsett visningsläge.

   VIKTIGT: en annan stilmall på sajten sätter display:none på vårt fyllnings-element
   (troligen en generisk regel som matchar klassnamnet av misstag). Därför tvingar vi
   display:block här direkt inline, istället för att bara lita på CSS-filen.

   Här mäter vi också headerns FAKTISKA höjd kontinuerligt via Shopifys egen namngivna
   header-group-wrapper, och applicerar aldrig ett uppmätt värde på 0px.

   Raden "Minsta möjliga order 150 kr" i varukorgen ([data-fm-min-order-note]) döljs
   här så fort totalen når 150 kr, som komplement till Liquid-villkoret i cart-drawer. */
(function () {
  var MIN_ORDER = 15000; // öre = 150 kr
  var FREE_FROM = 69900; // öre = 699 kr
  var COLORS = { red: '#e74c3c', yellow: '#f1c40f', green: '#27ae60' };
  var TEXT_COLORS = { red: '#c0392b', yellow: '#9a7d0a', green: '#1e8449' };

  function computeState(totalOre) {
    var pct = Math.max(0, Math.min((totalOre / FREE_FROM) * 100, 100));
    var state, text;

    if (totalOre >= FREE_FROM) {
      state = 'green';
      text = 'Fri frakt uppnådd! 🎉';
    } else if (totalOre < MIN_ORDER) {
      var remainToMin = Math.ceil((MIN_ORDER - totalOre) / 100);
      state = 'red';
      text = 'Lägg till ' + remainToMin + ' kr till (minsta order 150 kr)';
    } else {
      var remainToFree = Math.ceil((FREE_FROM - totalOre) / 100);
      state = 'yellow';
      text = remainToFree + ' kr kvar till fri frakt';
    }

    return { state: state, text: text, pct: pct };
  }

  function updateBar(bar, data) {
    bar.hidden = false;
    bar.setAttribute('data-fm-state', data.state);
    var fill = bar.querySelector('[data-fm-ship-fill]');
    var text = bar.querySelector('[data-fm-ship-text]');
    if (fill) {
      fill.style.display = 'block';
      fill.style.width = data.pct + '%';
      fill.style.height = '100%';
      fill.style.backgroundColor = COLORS[data.state];
    }
    if (text) {
      text.textContent = data.text;
      text.style.color = TEXT_COLORS[data.state];
    }
  }

  function toggleMinOrderNote(totalOre) {
    var notes = document.querySelectorAll('[data-fm-min-order-note]');
    for (var i = 0; i < notes.length; i++) {
      notes[i].hidden = totalOre >= MIN_ORDER;
    }
  }

  function refresh() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var allBars = document.querySelectorAll('[data-fm-ship-bar]');
        var floatingBars = document.querySelectorAll('.fm-ship-bar--floating[data-fm-ship-bar]');
        var total = cart.total_price || 0;

        toggleMinOrderNote(total);

        if (!cart.item_count) {
          for (var j = 0; j < floatingBars.length; j++) floatingBars[j].hidden = true;
          hasItems = false;
          return;
        }

        hasItems = true;
        var data = computeState(total);
        for (var i = 0; i < allBars.length; i++) {
          updateBar(allBars[i], data);
        }
        applyReveal();
      })
      .catch(function () {});
  }

  /* ---- FYNDMAXA: fördröjd visning av den flytande baren ----
     Om sidan innehåller ett element med [data-fm-ship-reveal-after] (Infoblocket
     under hero-bilden) hålls den flytande baren osynlig tills besökaren scrollat förbi
     hela den sektionen. Då fixeras baren under headern och tonas in. På sidor utan
     markör beter sig baren som förut (syns direkt när korgen har varor). */
  var hasItems = false;
  var revealMarker = null;
  var revealThreshold = 0;

  function findRevealMarker() {
    var els = document.querySelectorAll('[data-fm-ship-reveal-after]');
    if (!els.length) return null;
    var el = els[els.length - 1];
    return el.closest('.shopify-section') || el;
  }

  function computeRevealThreshold() {
    if (!revealMarker) return;
    var rect = revealMarker.getBoundingClientRect();
    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fm-header-height')) || 0;
    revealThreshold = rect.bottom + window.scrollY - headerH;
  }

  function applyReveal() {
    var floatingBars = document.querySelectorAll('.fm-ship-bar--floating[data-fm-ship-bar]');
    if (!floatingBars.length) return;
    if (!revealMarker) {
      for (var i = 0; i < floatingBars.length; i++) floatingBars[i].classList.add('is-revealed');
      return;
    }
    var show = hasItems && window.scrollY > revealThreshold;
    for (var k = 0; k < floatingBars.length; k++) {
      floatingBars[k].classList.add('fm-ship-reveal-mode');
      floatingBars[k].classList.toggle('is-revealed', show);
    }
  }

  function initReveal() {
    revealMarker = findRevealMarker();
    if (!revealMarker) { applyReveal(); return; }
    computeRevealThreshold();
    window.addEventListener('scroll', applyReveal, { passive: true });
    window.addEventListener('resize', function () { computeRevealThreshold(); applyReveal(); });
    setTimeout(function () { computeRevealThreshold(); applyReveal(); }, 500);
    setTimeout(function () { computeRevealThreshold(); applyReveal(); }, 1500);
    if (window.ResizeObserver) {
      new ResizeObserver(function () { computeRevealThreshold(); applyReveal(); }).observe(document.body);
    }
    applyReveal();
  }

  function findHeaderEl() {
    return (
      document.getElementById('shopify-section-group-header-group') ||
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header') ||
      (document.querySelector('.fm-ship-bar--floating') &&
        document.querySelector('.fm-ship-bar--floating').previousElementSibling)
    );
  }

  function trackHeaderHeight() {
    var headerEl = findHeaderEl();
    if (!headerEl) return;

    function apply() {
      var h = headerEl.getBoundingClientRect().height;
      if (h > 0) {
        document.documentElement.style.setProperty('--fm-header-height', h + 'px');
      }
    }

    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 1000);

    if (window.ResizeObserver) {
      new ResizeObserver(apply).observe(headerEl);
    } else {
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('resize', apply);
      setInterval(apply, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      refresh();
      trackHeaderHeight();
    });
  } else {
    initReveal();
    refresh();
    trackHeaderHeight();
  }

  // Temat meddelar varukorgsändringar via pubsub.js. Fliken kollar också om när den blir synlig (ändringar i annan flik).
  subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();
